import React from 'react';
import Parser from 'html-react-parser';
import {withScriptjs, withGoogleMap, GoogleMap, Marker} from "react-google-maps";

import './ContactPlaces.scss';

import bgImgs from '../../../assets/img/llc/contact/places';
import doctorsImgs from "../../../assets/img/llc/doctors";

class ContactPlaces extends React.Component {

  filterBranchesByType = (type) => {
    return this.props.branches.cities.filter(branch => branch.type === type);
  };

  renderMenuItems = (type) => {
    const branches = this.filterBranchesByType(type);
    return branches.map((branch) => {
      const activeClass = branch.id === this.props.branchActive ? "active" : "";
      return (
        <a
          key={branch.id}
          id={branch.id}
          className={`${activeClass}`}
          onClick={this.props.changeActiveTab}
        >{branch.name}</a>
      )
    });
  };

  renderBranch = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.props.branchActive);
    const main = this.props.langs.main;

    return (
      <div className="row">
        <div className="col-7 contactPlaces_openTime_info_col">
          <ul className="contactPlaces_openTime_info">
            {branch.tel && <li><i className="llc-phone-call"/> <strong>Tel.:</strong> {branch.tel}</li>}
            {branch.mobile && <li><i className="llc-smartphone"/> <strong>Mobil:</strong> {branch.mobile}</li>}
            {branch.fax && <li><i className="llc-fax"/> <strong>Fax :</strong> {branch.fax}</li>}
            {branch.email &&
            <li>
              <i className="llc-arroba"/>
              <strong>E-mail :</strong> <a href={`mailto:${branch.email}`}>{branch.email}</a>
            </li>
            }
            <li><i className="llc-placeholder"/> {branch.street}</li>
            <li>{`${branch.zip} ${branch.city}`}</li>
          </ul>
        </div>

        {/*
        {branch.opening_holidays &&
        <div className="col-5 contactPlaces_openTime_time_col">
          <div className="contactPlaces_openTime_time">
            <div className="contactPlaces_openTime_time_title">{main.opening_hours_holidays}:</div>
            <ul>
              <li><span>{main.days.mo}:</span> {branch.opening_holidays.mo}</li>
              <li><span>{main.days.tu}:</span> {branch.opening_holidays.tu}</li>
              <li><span>{main.days.we}:</span> {branch.opening_holidays.we}</li>
              <li><span>{main.days.th}:</span> {branch.opening_holidays.th}</li>
              <li><span>{main.days.fr}:</span> {branch.opening_holidays.fr}</li>
            </ul>
          </div>
        </div>
        }
        */}
        {branch.opening &&
        <div className="col-5 contactPlaces_openTime_time_col">
          <div className="contactPlaces_openTime_time">
            <div className="contactPlaces_openTime_time_title">{main.opening_hours}:</div>
            <ul>
              <li><span>{main.days.mo}:</span> {branch.opening.mo}</li>
              <li><span>{main.days.tu}:</span> {branch.opening.tu}</li>
              <li><span>{main.days.we}:</span> {branch.opening.we}</li>
              <li><span>{main.days.th}:</span> {branch.opening.th}</li>
              <li><span>{main.days.fr}:</span> {branch.opening.fr}</li>
            </ul>
          </div>
        </div>
        }
        {branch.openingAlt &&
        <div className="col-5 contactPlaces_openTime_time_col">
          <div className="contactPlaces_openTime_time">
            <div className="contactPlaces_openTime_time_title">{main.opening_hours}:</div>
            <ul>
              <li>{branch.openingAlt}</li>
            </ul>
          </div>
        </div>
        }
      </div>
    )
  };

  renderMap = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.props.branchActive);
    let MapWithAMarker = withScriptjs(withGoogleMap(props =>
      <GoogleMap
        defaultZoom={17}
        defaultCenter={{lat: branch.mapLat, lng: branch.mapLng}}
      >
        <Marker
          position={{lat: branch.mapLat, lng: branch.mapLng}}
        />
      </GoogleMap>
    ));

    /*
    return (
      <MapWithAMarker
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCOJm_YcTsXilBF1IWQQtbA7dy-U5F7yqs&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{height: `100%`}}/>}
        containerElement={<div style={{height: `420px`}}/>}
        mapElement={<div style={{height: `100%`}}/>}
      />
    )
    */

    return( branch.mapIframe )
  };


  renderVideo = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.props.branchActive);

    if (branch.video) {
      return (
        <div className="contactPlaces_video">
          <div className="container text-center">
            <iframe width="854" height="480" src={"https://www.youtube.com/embed/" + branch.video} frameBorder="0"
                    allowFullScreen/>
          </div>
        </div>
      )
    }
  };

  renderBg = () => {
    const branch = this.props.branches.cities.find(branch => branch.id === this.props.branchActive);

    return (
      <div className="contactPlaces_place_bg">
        <img src={bgImgs[branch.bgImg]}/>
      </div>
    )
  };

  render() {
    const footer = this.props.langs.footer;
    const branch = this.props.branches.cities.find(branch => branch.id === this.props.branchActive);

    return (
      <div className="contactPlaces">
        <div className="contactPlaces_place">
          <div className="container">
            <div className="contactPlaces_place_top">
              <div className="row">
                <div className="col-7">
                  <div className="contactPlaces_place_top_title">
                    <h3>{Parser(footer.title_left)} :</h3>
                  </div>
                  <div className="contactPlaces_place_top_menu">
                    {this.renderMenuItems(1)}
                  </div>
                </div>
                <div className="col-5 contactPlaces_place_top_menu_right">
                  <div className="contactPlaces_place_top_title">
                    <h3>{footer.title_right} :</h3>
                  </div>
                  <div className="contactPlaces_place_top_menu">
                    {this.renderMenuItems(2)}
                  </div>
                </div>
              </div>
            </div>

            <div className="contactPlaces_place_bot">
              <div className="row">
                <div className="col-7 contactPlaces_place_bot_left">
                  <h2 className="line text-center">{branch.city}</h2>
                  <div className="contactPlaces_place_bot_left_social">
                    <a
                      href="https://www.facebook.com/KLINIKA-LLC-PLASTICK%C3%81-CHIRURGIE-A-LASEROV%C3%89-L%C3%89%C4%8CEBN%C3%89-CENTRUM-114194068604606/"
                      target="_blank"><i className="llc-facebook-logo"/></a>
                    {/* <a href="#"><i className="llc-instagram"/></a> */}
                  </div>
                </div>
                <div className="col-5 contactPlaces_place_bot_right">
                  <div>
                    <h2>Volejte na naše telefonní číslo:</h2>
                    <div className="contactPlaces_place_bot_right_num">
                      <i className="llc-smartphone"/> {branch.mobile ? branch.mobile : branch.tel}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {this.renderBg()}
        </div>

        <div className="contactPlaces_openTime">
          <div className="container">
            {this.renderBranch()}
          </div>
        </div>

        {this.renderVideo()}
        {this.renderMap()}
      </div>
    );
  }
}

export default ContactPlaces;



// WEBPACK FOOTER //
// ./src/components/Contact/ContactPlaces/ContactPlaces.js